import _ from 'lodash'
import Backbone from 'backbone'
import Finder from 'scoreboard/components/finder'
import Tree from 'kalpa-tree'
import streamify from 'stream-array'
import i18n from 'scoreboard/components/i18n'

var LinkDatabase = Backbone.View.extend({

	// this.unlinkedDatabases is an array of the available databases

	className: 'link-database',

	initialize: function(options) {
		this.options = options || {}

		this.finder = new Finder()
		this.finder.on('find', this.find.bind(this))

		// add an icon to the databases
		var databases = _.map(this.options.unlinkedDatabases, function(db) {
			return _.extend({ icon: 'database' }, db)
		})
		this.tree = new Tree({
			forest: true,
			stream: streamify(databases)
		}).render()
		this.tree.on('select', this.trigger.bind(this, 'select'))
	},

	render: function() {
		this.$el.empty().append(this.finder.render().el, this.tree.el.node())

		this.$('.finder input').attr('placeholder', i18n.get('admin.databaseConnections.findDatabase'))
		this.$('ul').addClass('list list-striped list-striped-reversed')

		return this
	},

	find: function(text) {
		this.tree.search(text)
		// If you clear out the finder, prevent the first
		// node form getting ".selected" appended to it
		this.$('.node').removeClass('selected')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.finder, this.tree], 'remove')
	}

})

export default LinkDatabase

LinkDatabase.__filename__ = 'admin/licenses/link-database.js'
